
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { AppLinkParms, ExecutionResult, IFormMetadata, UrlModel } from "@tylertech/tyler-api-types";

/**
 * UrlService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class UrlService {
    private readonly $apiService = inject(ApiService);
    
    GetAppLink(pParms: AppLinkParms): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("IUrlService/GetAppLink", pParms);
    }
    GetFormMetadataUrl(formMetadata: IFormMetadata): Promise<string> {
        return this.$apiService.sendAuth("IUrlService/GetFormMetadataUrl", formMetadata);
    }
    GetUrl(pKey: string): Promise<ExecutionResult<UrlModel>> {
        return this.$apiService.sendAuth("IUrlService/GetUrl", pKey);
    }
}
